import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { UsersService } from '../../../services/users/users.service';
import { ToastComponent } from '../../../components/toast/toast.component';
import { TeamsService } from '../../../services/teams/teams.service';

@Component({
  selector: 'app-pay-with-method',
  templateUrl: './pay-with-method.page.html',
  styleUrls: ['./pay-with-method.page.scss'],
})
export class PayWithMethodComponent implements OnInit {

  public selectedAccount;
  public accounts = [];
  private wallitBalance: number;
  @Output() methodSelectedEvent = new EventEmitter();
  @Output() cancelEvent = new EventEmitter();


  constructor(
    private usersService: UsersService,
    private toastComponent: ToastComponent,
    private teamsService: TeamsService,
  ) { }

  async ngOnInit() {
    try {
      const myWallit = await this.usersService.myWallit();
      this.wallitBalance = myWallit.wallitBalance;
      const teams = await this.teamsService.getUserMemberTeams(this.usersService.me().user.id);
      const allowances = teams.filter(t => t.categories.some(cat => ['Insurance', 'Health & Wellness'].includes(cat))).map(t => {
        return {
          teamId: t.id,
          name: t.name,
          balance: t.balance,
        };
      });
      this.accounts = [
        // ...myWallit.accounts.filter(a => a.fundingSourceType === 'balance'),
        ...allowances,
        { name: 'Stripe Default Method', balance: '', icon: '/assets/icon/Accounts icon.svg' },
      ];


    } catch (error) {
      await this.toastComponent.presentToast('An error occurred while getting user\'s accounts information');
      console.log('An error occurred while getting user\'s accounts information', error);
    }
  }

  private isBalanceAccount(account): boolean {
    return account.fundingSourceType === 'balance';
  }

  lookupIcon(account) {
    return this.isBalanceAccount(account) || !account.icon || !account.icon ? '/assets/logo/Wallit - Brandmark.svg' : account.icon;
  }

  lookupBalance(account) {
    if (this.isBalanceAccount(account)) {
      return this.wallitBalance;
    }
    if (account.balance) {
      return account.balance;
    }
    return '';
  }

  lookupName(account) {
    if (this.isBalanceAccount(account)) {
      return 'Wallit Balance';
    }
    return `${account.name}`;
  }

  accountSelected(value) {
    this.selectedAccount = value;
  }

  async selectMethod() {
    const method = this.selectedAccount.teamId ? this.selectedAccount.teamId : (this.isBalanceAccount(this.selectedAccount) ? 'wallit' : 'stripe');
    this.methodSelectedEvent.emit(method);
  }
}
